import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AttendanceCase_Attended_getInstance2ikeef3q5e60n as AttendanceCase_Attended_getInstance } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  Semanticpmpmvt7fldq2 as Semantic,
  HoverSemantic_getInstance3081oh8o0tv4w as HoverSemantic_getInstance,
  override1oesdgz72e8ey as override,
  DownSemantic_getInstancejvxqp4oqx0tj as DownSemantic_getInstance,
  _SemanticOverrides___init__impl__g2p3k812zbkczmal1zf as _SemanticOverrides___init__impl__g2p3k8,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_dp246mt9ygxfnpl as get_dp,
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Fixed1p8lc8swyflir as Fixed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { Companion_getInstance252uiobns9yoh as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  Companion_getInstance2u620q9r4ejbj as Companion_getInstance_0,
  GradientStoph1mm28b0oix as GradientStop,
  LinearGradient2qftccjwl6uey as LinearGradient,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { rangeToeizvz34h11nd as rangeTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  _Angle___init__impl__g23q1m3btd89vsaotdr as _Angle___init__impl__g23q1m,
  _Angle___get_turns__impl__atdtw5psbuz3qdt26e as _Angle___get_turns__impl__atdtw5,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Angle.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  AttendanceCellState_Attended_instance = new (AttendanceCellState())('Attended', 0, '', AttendanceCellState$lambda);
  AttendanceCellState_ExplainedAbsence_instance = new (AttendanceCellState())('ExplainedAbsence', 1, '', AttendanceCellState$lambda_0);
  AttendanceCellState_UnexplainedAbsence_instance = new (AttendanceCellState())('UnexplainedAbsence', 2, '', AttendanceCellState$lambda_1);
  AttendanceCellState_Closure_instance = new (AttendanceCellState())('Closure', 3, '', AttendanceCellState$lambda_2);
  AttendanceCellState_NotScheduled_instance = new (AttendanceCellState())('NotScheduled', 4, '', AttendanceCellState$lambda_3);
  AttendanceCellState_NotPlaced_instance = new (AttendanceCellState())('NotPlaced', 5, '\u2014', AttendanceCellState$lambda_4);
  AttendanceCellState_NeedsEntry_instance = new (AttendanceCellState())('NeedsEntry', 6, '+', AttendanceCellState$lambda_5);
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var AttendanceCellState_Attended_instance;
var AttendanceCellState_ExplainedAbsence_instance;
var AttendanceCellState_UnexplainedAbsence_instance;
var AttendanceCellState_Closure_instance;
var AttendanceCellState_NotScheduled_instance;
var AttendanceCellState_NotPlaced_instance;
var AttendanceCellState_NeedsEntry_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      of_fosl41_k$(case_0) {
        return !(case_0.closureReason_1 == null) ? AttendanceCellState_Closure_getInstance() : case_0.equals(AttendanceCase_Attended_getInstance()) ? AttendanceCellState_Attended_getInstance() : case_0.explained_1 === true ? AttendanceCellState_ExplainedAbsence_getInstance() : AttendanceCellState_UnexplainedAbsence_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function values() {
  static_init();
  return [AttendanceCellState_Attended_getInstance(), AttendanceCellState_ExplainedAbsence_getInstance(), AttendanceCellState_UnexplainedAbsence_getInstance(), AttendanceCellState_Closure_getInstance(), AttendanceCellState_NotScheduled_getInstance(), AttendanceCellState_NotPlaced_getInstance(), AttendanceCellState_NeedsEntry_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
function AttendanceCellState$lambda(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStateAttended_v3hons_k$();
}
function AttendanceCellState$lambda_0(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStateExplainedAbsence_9yyv4q_k$();
}
function AttendanceCellState$lambda_1(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStateUnexplainedAbsence_uqoym9_k$();
}
function AttendanceCellState$lambda_2(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStateClosure_cr4gsc_k$();
}
function AttendanceCellState$lambda_3(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStateNotScheduled_obpiih_k$();
}
function AttendanceCellState$lambda_4(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStateNotPlaced_4v4cr3_k$();
}
function AttendanceCellState$lambda_5(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStateNeedsEntry_c829o4_k$();
}
var $ENTRIES;
var AttendanceCellStateClass;
function AttendanceCellState() {
  if (AttendanceCellStateClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, mark, explanation) {
        super(name, ordinal);
        this.mark_1 = mark;
        this.explanation_1 = explanation;
      }
    }
    initMetadataForClass($, 'AttendanceCellState');
    AttendanceCellStateClass = $;
  }
  return AttendanceCellStateClass;
}
var AttendanceTableCellClass;
function AttendanceTableCell() {
  if (AttendanceTableCellClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        AttendanceTableCell_instance = null;
        super('attend-cell');
        AttendanceTableCell_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_outlineWidth = get_dp(0.5);
        var tmp1_gap = get_rem(1);
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, tmp1_gap, VOID, VOID, VOID, VOID, tmp0_outlineWidth);
      }
      toString() {
        return 'AttendanceTableCell';
      }
      hashCode() {
        return -2115886968;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AttendanceTableCell()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'AttendanceTableCell');
    AttendanceTableCellClass = $;
  }
  return AttendanceTableCellClass;
}
var AttendanceTableCell_instance;
function AttendanceTableCell_getInstance() {
  if (AttendanceTableCell_instance === VOID)
    new (AttendanceTableCell())();
  return AttendanceTableCell_instance;
}
function AttendanceEntryBox$default$lambda($this$override, it) {
  return $this$override.withBack$default_t8expd_k$(it);
}
function AttendanceEntryBox$default$lambda_0($this$override, it) {
  return $this$override.withBack$default_t8expd_k$(it);
}
var AttendanceEntryBoxClass;
function AttendanceEntryBox() {
  if (AttendanceEntryBoxClass === VOID) {
    class $ extends Semantic() {
      constructor(state) {
        super('acell-' + state.toString());
        this.state_1 = state;
      }
      default_buqihh_k$(theme) {
        var tmp2_cornerRadii = new (Fixed())(get_dp_0(4));
        var tmp3_outlineWidth = get_dp_0(0);
        var tmp0_$this = theme.font_1;
        var tmp1_size = get_dp_0(11);
        var tmp4_font = tmp0_$this.copy$default_cfilcw_k$(VOID, VOID, 600, VOID, VOID, VOID, tmp1_size);
        var tmp5_padding = Companion_getInstance().ZERO_1;
        var it = this.alter$default_u3pj3s_k$(theme, VOID, tmp4_font, VOID, tmp2_cornerRadii, VOID, VOID, tmp5_padding, VOID, VOID, VOID, tmp3_outlineWidth);
        var tmp;
        switch (this.state_1.ordinal_1) {
          case 0:
            var tmp7_background = Companion_getInstance_0().fromHexString_vb3go_k$('#e7f5ee');
            var tmp8_foreground = Companion_getInstance_0().fromHexString_vb3go_k$('#006225');
            tmp = this.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp8_foreground, VOID, VOID, VOID, VOID, tmp7_background);
            break;
          case 1:
            var tmp9_background = Companion_getInstance_0().fromHexString_vb3go_k$('#fbeecb');
            var tmp10_foreground = Companion_getInstance_0().fromHexString_vb3go_k$('#8a5900');
            tmp = this.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp10_foreground, VOID, VOID, VOID, VOID, tmp9_background);
            break;
          case 2:
            var tmp11_background = Companion_getInstance_0().fromHexString_vb3go_k$('#fceceb');
            var tmp12_foreground = Companion_getInstance_0().fromHexString_vb3go_k$('#B30838');
            tmp = this.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp12_foreground, VOID, VOID, VOID, VOID, tmp11_background);
            break;
          case 3:
            var tmp13_background = Companion_getInstance_0().fromHexString_vb3go_k$('#eaf1fb');
            var tmp14_foreground = Companion_getInstance_0().fromHexString_vb3go_k$('#133f78');
            tmp = this.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp14_foreground, VOID, VOID, VOID, VOID, tmp13_background);
            break;
          case 4:
            var count = 8;
            var slight = 1.0E-6;
            var background = it.background_1.closestColor_akwbqu_k$();
            var stripeColor = Companion_getInstance_0().interpolate_s30y89_k$(background, Companion_getInstance_0().gray_1, 0.15);
            // Inline function 'kotlin.collections.map' call

            var this_0 = until(0, count);
            // Inline function 'kotlin.collections.mapTo' call

            var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
            var inductionVariable = this_0.first_1;
            var last = this_0.last_1;
            if (inductionVariable <= last)
              do {
                var item = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var it_0 = item;
                var tmp$ret$2 = rangeTo(it_0 / count, (it_0 + 1 | 0) / count);
                destination.add_utx5q5_k$(tmp$ret$2);
              }
               while (!(item === last));
            // Inline function 'kotlin.collections.flatMap' call

            // Inline function 'kotlin.collections.flatMapTo' call

            var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            var _iterator__ex2g4s = destination.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              var list = listOf([new (GradientStop())(element.get_start_iypx6h_k$(), stripeColor), new (GradientStop())(element.get_start_iypx6h_k$() + slight, background), new (GradientStop())((element.get_start_iypx6h_k$() + element.get_endInclusive_r07xpi_k$()) / 2, background), new (GradientStop())((element.get_start_iypx6h_k$() + element.get_endInclusive_r07xpi_k$()) / 2 + slight, stripeColor)]);
              addAll(destination_0, list);
            }

            var tmp_0 = destination_0;
            // Inline function 'com.lightningkite.kiteui.models.turns' call

            // Inline function 'com.lightningkite.kiteui.models.Angle.div' call

            var this_1 = _Angle___init__impl__g23q1m(1);
            var tmp$ret$7 = _Angle___init__impl__g23q1m(_Angle___get_turns__impl__atdtw5(this_1) / 8.0);
            tmp = this.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new (LinearGradient())(tmp_0, tmp$ret$7));
            break;
          case 5:
            var tmp_1 = HoverSemantic_getInstance();
            var tmp_2 = override(tmp_1, AttendanceEntryBox$default$lambda);
            var tmp_3 = DownSemantic_getInstance();
            tmp = this.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _SemanticOverrides___init__impl__g2p3k8([tmp_2, override(tmp_3, AttendanceEntryBox$default$lambda_0)]));
            break;
          case 6:
            tmp = this.withBack$default_t8expd_k$(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, get_dp_0(1));
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
      toString() {
        return 'AttendanceEntryBox(state=' + this.state_1.toString() + ')';
      }
      hashCode() {
        return this.state_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AttendanceEntryBox()))
          return false;
        if (!this.state_1.equals(other.state_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AttendanceEntryBox');
    AttendanceEntryBoxClass = $;
  }
  return AttendanceEntryBoxClass;
}
function AttendanceCellState_Attended_getInstance() {
  static_init();
  return AttendanceCellState_Attended_instance;
}
function AttendanceCellState_ExplainedAbsence_getInstance() {
  static_init();
  return AttendanceCellState_ExplainedAbsence_instance;
}
function AttendanceCellState_UnexplainedAbsence_getInstance() {
  static_init();
  return AttendanceCellState_UnexplainedAbsence_instance;
}
function AttendanceCellState_Closure_getInstance() {
  static_init();
  return AttendanceCellState_Closure_instance;
}
function AttendanceCellState_NotScheduled_getInstance() {
  static_init();
  return AttendanceCellState_NotScheduled_instance;
}
function AttendanceCellState_NotPlaced_getInstance() {
  static_init();
  return AttendanceCellState_NotPlaced_instance;
}
function AttendanceCellState_NeedsEntry_getInstance() {
  static_init();
  return AttendanceCellState_NeedsEntry_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  AttendanceCellState_Closure_getInstance as AttendanceCellState_Closure_getInstanced8orc2c03u9w,
  AttendanceCellState_NeedsEntry_getInstance as AttendanceCellState_NeedsEntry_getInstance1nr9dxyvhbguy,
  AttendanceCellState_NotPlaced_getInstance as AttendanceCellState_NotPlaced_getInstancedryb5nvy8nlp,
  AttendanceCellState_NotScheduled_getInstance as AttendanceCellState_NotScheduled_getInstance3itq8wmesmvbz,
  Companion_instance_0 as Companion_instance3avuh2je008a9,
  AttendanceTableCell_getInstance as AttendanceTableCell_getInstance1kwc03bvz0h68,
  get_entries as get_entries1r7oopv3kkcq7,
  AttendanceEntryBox as AttendanceEntryBox2fe5zhsdvgxaf,
};
//endregion

//# sourceMappingURL=attendanceStyling.mjs.map
